// This icon file is generated automatically.
var PtoArrLogoutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M27.13 22.88h-2.2a.5.5 0 00-.39.18 11.06 11.06 0 01-16.36.77 11.04 11.04 0 017.83-18.9 10.97 10.97 0 018.53 4.01c.1.12.24.19.39.19h2.2c.2 0 .31-.22.2-.39-2.4-3.72-6.59-6.19-11.35-6.18a13.45 13.45 0 1011.36 20.7.25.25 0 00-.21-.38zm2.77-7.08l-4.43-3.5a.25.25 0 00-.4.2v2.38h-9.82a.25.25 0 00-.25.24v1.76c0 .13.11.25.25.25h9.81v2.37c0 .2.25.33.4.2l4.44-3.5c.13-.1.13-.3 0-.4z", "fill-rule": "nonzero" } }] }, "name": "pto-arr-logout", "theme": "outlined" };
export default PtoArrLogoutOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoArrLogoutOutlined.js
// module id = 3868
// module chunks = 0